// ============================================
// Cart Cross-Sell
// ============================================

// === Add-to-Cart Handler ===
if (!customElements.get('cart-cross-sell')) {
  customElements.define('cart-cross-sell', class CartCrossSell extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.cross-sell-form').forEach(form => {
        form.addEventListener('submit', this.onSubmit.bind(this));
      });
    }

    onSubmit(evt) {
      evt.preventDefault();
      const form = evt.target;
      const btn = form.querySelector('button[type="submit"]');
      const spinner = btn.querySelector('.loading-overlay__spinner');

      btn.setAttribute('disabled', true);
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData(form);
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(s => s.id));
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(r => r.json())
        .then(response => {
          if (response.status) return;
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-cross-sell', productVariantId: formData.get('id') });
          }
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(response);
        })
        .catch(() => {})
        .finally(() => {
          btn.removeAttribute('disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }
  });
}

// === Drawer Carousel (transform-based, touch + mouse drag) ===
class CrossSellCarousel {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('[data-carousel-track]');
    this.slides = Array.from(el.querySelectorAll('[data-carousel-slide]'));
    this.pagination = el.parentElement.querySelector('[data-carousel-pagination]');
    this.current = 0;
    this.dragging = false;
    this.startX = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;

    if (this.slides.length === 0) return;

    this.bindEvents();
    this.buildPagination();
    this.goTo(0, false);
  }

  // Each slide is 80% wide. The offset puts the current slide flush-left
  // with 20% of the next one peeking in from the right.
  getOffset(index) {
    // 80% of the container per slide
    const slidePercent = 80;
    return -(index * slidePercent);
  }

  goTo(index, animate) {
    if (index < 0) index = 0;
    if (index >= this.slides.length) index = this.slides.length - 1;
    this.current = index;

    const pct = this.getOffset(index);
    this.prevTranslate = pct;
    this.currentTranslate = pct;

    this.track.style.transition = animate !== false ? 'transform 0.35s ease' : 'none';
    this.track.style.transform = `translateX(${pct}%)`;

    this.updateDots();
  }

  // --- Touch / Mouse ---
  bindEvents() {
    // Touch – horizontal drag captured, vertical passes through
    this.track.addEventListener('touchstart', e => {
      this.touchStartY = e.touches[0].clientY;
      this.dragStart(e.touches[0].clientX);
    }, { passive: true });

    this.track.addEventListener('touchmove', e => {
      const dx = Math.abs(e.touches[0].clientX - this.startX);
      const dy = Math.abs(e.touches[0].clientY - this.touchStartY);
      // Only capture horizontal swipes
      if (dx > dy && dx > 5) {
        e.preventDefault();
        e.stopPropagation();
        this.dragMove(e.touches[0].clientX);
      } else if (dy > dx) {
        // Vertical – cancel drag and let drawer scroll
        this.dragging = false;
      }
    }, { passive: false });

    this.track.addEventListener('touchend', () => this.dragEnd());

    // Mouse
    this.track.addEventListener('mousedown', e => {
      if (e.target.closest('a, button, select')) return;
      e.preventDefault();
      this.dragStart(e.clientX);
    });
    window.addEventListener('mousemove', e => {
      if (!this.dragging) return;
      e.preventDefault();
      this.dragMove(e.clientX);
    });
    window.addEventListener('mouseup', () => {
      if (this.dragging) this.dragEnd();
    });
  }

  dragStart(x) {
    this.dragging = true;
    this.startX = x;
    this.track.style.transition = 'none';
    this.track.style.cursor = 'grabbing';
  }

  dragMove(x) {
    if (!this.dragging) return;
    const diff = x - this.startX;
    const containerWidth = this.el.offsetWidth;
    // Convert pixel drag to percentage
    const pctDiff = (diff / containerWidth) * 100;
    this.currentTranslate = this.prevTranslate + pctDiff;
    this.track.style.transform = `translateX(${this.currentTranslate}%)`;
  }

  dragEnd() {
    this.dragging = false;
    this.track.style.cursor = '';
    const moved = this.currentTranslate - this.prevTranslate;

    // Threshold: if dragged more than 15% of container, advance
    if (moved < -15) {
      this.goTo(this.current + 1);
    } else if (moved > 15) {
      this.goTo(this.current - 1);
    } else {
      this.goTo(this.current); // snap back
    }
  }

  // --- Pagination ---
  buildPagination() {
    if (!this.pagination) return;
    this.pagination.innerHTML = '';
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'cross-sell-pagination__dot';
      dot.setAttribute('aria-label', `Slide ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.pagination.appendChild(dot);
    });
    this.updateDots();
  }

  updateDots() {
    if (!this.pagination) return;
    this.pagination.querySelectorAll('.cross-sell-pagination__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }
}

// === Initialization ===
function initCarousels() {
  // Drawer: Custom carousel
  document.querySelectorAll('[data-carousel]').forEach(el => {
    if (el._carousel) return; // already initialised
    el._carousel = new CrossSellCarousel(el);
  });
}

function initSwiperCrossSell() {
  // Main Cart: Swiper
  const swiperEl = document.querySelector('.products-slider--cross-sell .swiper');
  if (!swiperEl || swiperEl.swiper) return;

  new Swiper(swiperEl, {
    slidesPerView: 2,
    spaceBetween: 16,
    speed: 1100,
    keyboard: true,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
    pagination: {
      el: '.products-slider--cross-sell .swiper-pagination',
      clickable: true,
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCarousels();
  initSwiperCrossSell();

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(() => {
        initCarousels();
        initSwiperCrossSell();
      }, 300);
    });
  }
});

// Re-init carousel when drawer opens (needs visible container for dimensions)
(function observeDrawer() {
  const init = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(() => {
      if (drawer.classList.contains('active') || drawer.classList.contains('animate')) {
        setTimeout(initCarousels, 200);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
